import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const unsavePost = async (postId: string) => {
	const response = await cmsClient.delete(`/saved-posts/${postId}/`);
	return response.data;
};

const useUnsavePost = () => {
	const queryClient = useQueryClient();

	return useMutation(unsavePost, {
		onSettled: () => {
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useUnsavePost;
